<script setup lang="ts">
import { CheckboxComponent, CountBadgeComponent } from '@metapic-apps/shared'
import { computed } from 'vue'

import ChevronIcon from '@/assets/icons/chevron.svg?component'
import type { ListItemsType } from '@/lib/types/common.types'
import { BoxComponent, FlexComponent, TypographyComponent } from '@/ui-library'

defineProps<{ moreFiltersItems: ListItemsType; shouldTruncateText?: boolean }>()
const createdByMe = defineModel<boolean>('createdByMe', { default: false })
const statuses = defineModel<string[]>('statuses', { default: [] })
const activeFiltersAmount = computed(() => Number(createdByMe.value) + statuses.value.length)
</script>
<template>
  <el-dropdown trigger="click" :hide-on-click="false">
    <BoxComponent :p="10">
      <FlexComponent :gap="8" align="center">
        <TypographyComponent variant="label-large"> More filters </TypographyComponent>
        <CountBadgeComponent :count="activeFiltersAmount" />
        <el-icon :size="18" class="chevron-icon">
          <ChevronIcon />
        </el-icon>
      </FlexComponent>
    </BoxComponent>
    <template #dropdown>
      <BoxComponent :pt="8" :pb="8">
        <FlexComponent direction="column">
          <CheckboxComponent v-model="createdByMe" class="more-filters__checkbox"> Created by me </CheckboxComponent>
          <template v-if="moreFiltersItems?.length">
            <el-divider />
            <el-checkbox-group v-model="statuses">
              <FlexComponent direction="column">
                <CheckboxComponent v-for="item in moreFiltersItems" :key="item.value" :value="item.value" class="more-filters__checkbox">
                  {{ item.label }}
                </CheckboxComponent>
              </FlexComponent>
            </el-checkbox-group>
          </template>
        </FlexComponent>
      </BoxComponent>
    </template>
  </el-dropdown>
</template>
<style lang="scss" scoped>
.more-filters__checkbox {
  padding: 16px;
  --el-checkbox-height: 56px;
}

:deep(.el-checkbox) {
  margin-right: 0;
}
:deep(.el-divider--horizontal) {
  margin: 8px 0;
}
</style>
